var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWireless(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 12.1667C1.38405 12.1667 2.2319 12.5179 2.85702 13.143C3.48214 13.7681 3.83333 14.6159 3.83333 15.5H0.5V12.1667ZM0.5 6.33333C5.5625 6.33333 9.66667 10.4375 9.66667 15.5H8C8 13.5109 7.20982 11.6032 5.8033 10.1967C4.39678 8.79018 2.48912 8 0.5 8V6.33333ZM0.5 0.5C8.78417 0.5 15.5 7.21583 15.5 15.5H13.8333C13.8333 8.13583 7.86417 2.16667 0.5 2.16667V0.5Z",
    fill: "#555A5A"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWireless);
export default __webpack_public_path__ + "static/media/wireless.bbf192a38c31289f77bc82fa794c218c.svg";
export { ForwardRef as ReactComponent };